import { controllingSelectBucket as controllingSelectBucketPureAction } from '../../store/controlling/actions';
import { paintingSetForce, paintingSetGetForceFromPen, paintingSetMedium as paintingSetMediumPureAction } from '../../store/painting/actions';
import store from '../../store/store';

function bind(actionCreator, dispatch) {
  return function (...args) {
    return dispatch(actionCreator(...args));
  };
}

export const setMedium = bind(paintingSetMediumPureAction, store.dispatch);

export const selectBucket = bind(controllingSelectBucketPureAction, store.dispatch);

export const setForce = bind(paintingSetForce, store.dispatch);

export const setGetForceFromPen = bind(paintingSetGetForceFromPen, store.dispatch);
